import type { AcceptMissionRotationInfoDto } from '../../api/api.g';

export const isLinkedMysteryShopperRotationLimitReached = (rotationInfo?: AcceptMissionRotationInfoDto) =>
  rotationInfo?.isBlockedByLinkedMysteryShopper === true;
